module.exports = __webpack_public_path__ + "img/Soup.1574cf68.jpg";